import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardStatusIcon',
  props: {
  isActive: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const props = __props;


const {
  t,
} = useI18n();




return { __sfc: true,t, props }
}

})